import React from 'react';

import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SvgIcon,
} from '@mui/material';
import FlightIcon from '@mui/icons-material/Flight';

import FlightSegmentCrewStack from '../../components/FlightSegmentCrewStack';
import FlightSegmentTimesStack from '../../components/FlightSegmentTimesStack';

import { FlightOperationNotification } from '../../core/api/clients';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useSaveNewFlightOperationNotification from '../../core/api/hooks/flight-operation/useSaveNewFlightOperationNotification';

function FlightOperationNotificationNewOptions({ data }: {
  data: FlightOperationNotification[] }) {
  const [segments, setSegments] = React.useState<FlightOperationNotification[]>([]);
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const { mutate: saveNewFlightOperationNotification } = useSaveNewFlightOperationNotification();
  const navigate = useNavigate();
  const authorizedFormData = useAuthorizedFormData();

  React.useEffect(() => {
    if (data !== null && data.length > 0) {
      setSegments(data);
      setOpen(true);
    }
  }, [data]);

  const createFlight = (report: FlightOperationNotification) => {
    saveNewFlightOperationNotification(report, {
      onSuccess: (flightOperationNotification: FlightOperationNotification) => {
        navigate(`${authorizedFormData.metadata?.route}/${flightOperationNotification.id}/edit`, { replace: true });
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>Multiple Segments Found</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please select the flight segment for which you want to create a form
        </DialogContentText>
        <List>
          {segments.map((item) => (
            <ListItem
              key={item.createdOn}
              disablePadding
              sx={{ py: 0 }}
            >
              <ListItemButton
                sx={{ padding: 2 }}
                onClick={() => createFlight(item)}
              >
                <ListItemIcon sx={{ ml: 2 }}>
                  <SvgIcon>
                    <FlightIcon />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText
                  primary={`${item.aircraftNumber} | ${item.departureAirport} - ${item.landingAirport}`}
                  secondary={(
                    <Stack>
                      <FlightSegmentTimesStack
                        pushTime={item.pushTime}
                        outTime={item.outTime}
                        offTime={item.offTime}
                        onTime={item.onTime}
                        inTime={item.inTime}
                      />
                      <FlightSegmentCrewStack
                        captain={item.captain}
                        firstOfficer={item.firstOfficer}
                        flightAttendant1={item.flightAttendant}
                      />
                    </Stack>
                  )}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default FlightOperationNotificationNewOptions;
